import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

(window as any).__TAGIT_APP_BOOTED__ = true;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
